<template>
  <v-data-table
    :items="items"
    :headers="headers"
    :footer-props="{
      'items-per-page-options': [25,50,100,-1]
    }"
    class="elevation-1"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td
          v-for="(granted, i) in item"
          :key="`permission-${i}`"
        >
          <span v-if="i === 0">{{ granted }}</span>

          <div v-else>
            <v-checkbox
              :input-value="granted"
              color="primary"
              hide-details
              disabled
              class="justify-center ma-0"
            />
          </div>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import permissions from '@/roles/permissions'

export default {
  data () {
    return {
      allRoles: [
        // organization
        'owner',
        'member',

        // plans
        'full',
        'beta'
      ],
      allPermissions: [
        'project',
        'portfolio',
        'user',
        'resources',
        'organization',
        'integrations',
        'billing'
      ],
      items: [],
      headers: [ ]
    }
  },
  mounted () {
    this.headers = this.allRoles.map(role => {
      return { text: role, value: role, sortable: false, align: 'center' }
    })
    this.headers.unshift({ text: 'Permission', value: 'x' })

    for (let permission of this.allPermissions) {
      const grant = [ permission ]

      for (let role of this.allRoles) {
        grant.push(!!permissions[role][permission])
      }

      this.items.push(grant)
    }
  }
}
</script>

<style>

</style>
